var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status-filter"},_vm._l((_vm.computedStatuses),function(status){return _c('Button',{key:status,class:[
      'status-button',
      _vm.selectedStatus === status ? 'text7 selected' : 'text8',
    ],attrs:{"id":`button--status-filter-${status}`},nativeOn:{"click":function($event){return _vm.$emit('update:value', status !== 'all' ? status : null)}}},[_vm._v(" "+_vm._s(_vm.$t(`request.my-requests.status.${status}`))+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }